import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, Button, Alert } from "@/Components/Common/Tailwind";
import { API } from "../../api";
import { getAccessToken } from "../../api/auth";

interface TicketInfo {
  id: number;
  name: string;
  expiration_date: string;
  orderDate: string;
  amount: number;
  can_refund_each: boolean;
  bundleCount: number;
  isCancelable: boolean;
}

interface PurchaseTicketModalProps {
  info: TicketInfo;
  setInfo: (info: TicketInfo | {}) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  navigate: (path: number | string) => void;
  needRefresh?: () => void;
}

const PurchaseTicketModal = (props: PurchaseTicketModalProps) => {
  const [loading, setLoading] = useState(false);

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const goCancel = () => {
    const accessToken = getAccessToken();
    setLoading(true);

    API.post(
      "/ticket/cancel-ticket/",
      { id: props.info.id },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((response) => {
        if (response.data.result === "ok") {
          toast.success("취소 요청이 처리 되었습니다.");
          props.setInfo({});
          props.setVisible(false);
          props.needRefresh ? props.needRefresh() : props.navigate(0);
        } else if (response.data["error"]) {
          toast.error("취소 요청이 처리되지 않았습니다. " + response.data["error"]);
        } else {
          toast.error("취소 요청이 처리되지 않았습니다. " + response.data);
        }
      })
      .catch((error) => {
        toast.error("취소 요청이 처리되지 않았습니다. " + error.toString());
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Modal toggle={togModal} isOpen={props.visible} centered>
        <div className="pt-4">
          <ul className="list-group">
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">예약상품 :</span>
              <span>{props.info.name}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">만료일 :</span>
              <span>{props.info.expiration_date}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">결제일 :</span>
              <span>{props.info.orderDate}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">환불금액 :</span>
              <span>{
                props.info.can_refund_each ?
                  props.info.amount :
                  Math.round(props.info.amount * props.info.bundleCount * 0.1) * 10
              }</span>
            </li>
          </ul>
          {props.info.bundleCount > 1 && !props.info.isCancelable && !props.info.can_refund_each ? (
            <div className="mt-2.5 pl-1.5 text-center font-medium">티켓 번들중 하나라도 사용하면 모두 남은 번들도 모두 환불 불가 합니다.</div>
          ) : props.info.bundleCount > 1 && !props.info.can_refund_each ? (
            <div className="mt-2.5 pl-1.5 text-center font-medium">번들 상품의 경우 환불시 번들 모두 환불 됩니다.</div>
          ) : null}
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="secondary"
            disabled={loading}
            onClick={() => {
              props.setInfo({});
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
          <Button
            variant="danger"
            disabled={loading}
            onClick={goCancel}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm align-middle"
                  style={{ marginRight: "8px" }}
                  role="status"
                  aria-hidden="true"
                />
                처리 중...
              </>
            ) : "환불"}
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default PurchaseTicketModal;
